export const HEIGHT = 40;
export const GAP = 24;
export const HAMBURGER_MENU_WIDTH = 28;
export const TNP_LOGO_WIDTH = 84;
